import * as React from "react";
import { fixedColumns, tableItemsNoIcons } from "./TableData";

import { ScreenBreakpoints } from "azure-devops-ui/Core/Util/Screen";
import { Card } from "azure-devops-ui/Card";
import { ITableBreakpoint, Table } from "azure-devops-ui/Table";
import "./Table.Example.css";

export default class TableWithBreakpointsExample extends React.Component {
    public render(): JSX.Element {
        return (
            <Card className="flex-grow bolt-table-card" contentProps={{ contentPadding: false }}>
                <Table
                    ariaLabel="Table with breakpoints"
                    columns={fixedColumns}
                    itemProvider={tableItemsNoIcons}
                    role="table"
                    className="table-example"
                    containerClassName="h-scroll-auto"
                    tableBreakpoints={this.tableBreakpoints}
                />
            </Card>
        );
    }

    private tableBreakpoints: ITableBreakpoint[] = [
        {
            breakpoint: ScreenBreakpoints.xsmall,
            columnWidths: [-100, 0, 0],
        },
        {
            breakpoint: ScreenBreakpoints.small,
            columnWidths: [-40, -20, -40],
        },
    ];
}
